// 補登用的兩個小工具(業主 2026-11-02:「補登的邏輯也有問題 …… 希望補登可以出現要補哪個」)。
//
// 1. 時間一律 24 小時制,打字輸入。瀏覽器原生的時間欄有「上午/下午」,打「5」會變成
//    上午 05:00 —— 正式站上真的有人想補下午 5 點的下班卡,存成了凌晨 5 點。
// 2. 列出這個月還缺哪張卡,點一下就把日期與上班/下班帶進補登表。

import type { AttendanceMonthDay } from "../../api/types";

/**
 * 使用者打的時間 → `HH:MM`(24 小時制)。看不懂回 `null`。
 *
 * 收:`17:30`、`1730`、`930`、`9:30`、`17`、`17.30`、`17：30`。
 */
export function parseClock(raw: string): string | null {
  const text = raw.trim().replace(/[：.]/g, ":");
  let hour: number;
  let minute: number;
  const colon = /^(\d{1,2}):(\d{1,2})$/.exec(text);
  const digits = /^\d{1,4}$/.exec(text);
  if (colon) {
    hour = Number(colon[1]);
    minute = Number(colon[2]);
  } else if (digits) {
    if (text.length <= 2) {
      hour = Number(text);
      minute = 0;
    } else {
      hour = Number(text.slice(0, -2));
      minute = Number(text.slice(-2));
    }
  } else {
    return null;
  }
  if (hour > 23 || minute > 59) return null;
  return `${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}`;
}

/** `17:30` → `下午 5:30`;給人對一下有沒有填錯上午/下午。 */
export function spokenClock(hhmm: string): string {
  const [h, m] = hhmm.split(":").map(Number);
  const part = h < 12 ? "上午" : "下午";
  const twelve = h % 12 === 0 ? 12 : h % 12;
  return `${part} ${twelve}:${String(m).padStart(2, "0")}`;
}

export interface MissingPunch {
  /** `YYYY-MM-DD` */
  date: string;
  kind: "IN" | "OUT";
}

/**
 * 這個月還缺哪幾張卡。
 *
 * * 只看**今天以前(含今天)**;今天只問上班卡 —— 下班卡今天還沒到時候。
 * * 一整天的假(核准或待核准)不算缺。
 * * 週末與國定假日一張卡都沒有就是放假,不算缺;有打一張就照樣檢查另一張。
 * * 平日一張都沒有:上班、下班都缺。
 */
export function missingPunches(
  days: AttendanceMonthDay[],
  today: string,
  isDayOff: (iso: string) => boolean,
): MissingPunch[] {
  const out: MissingPunch[] = [];
  for (const day of days) {
    const iso = day.work_date;
    if (iso > today) continue;
    if (day.leave && day.leave.period === "FULL") continue;
    const ins = day.punches.filter((p) => p.kind === "IN").length;
    const outs = day.punches.filter((p) => p.kind === "OUT").length;
    if (ins === 0 && outs === 0 && (day.weekday >= 6 || isDayOff(iso))) continue;
    if (ins === 0) out.push({ date: iso, kind: "IN" });
    if (iso < today && (outs === 0 || day.working)) out.push({ date: iso, kind: "OUT" });
  }
  return out;
}
